import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
//import { Layout } from './Layout';
//import { MDBIcon } from 'mdb-react-ui-kit';
import { MDBInputGroup, MDBInput, MDBIcon, MDBBtn, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import Header from './Header';
import { MDBSpinner } from 'mdb-react-ui-kit';

export default function Login() {
  const { login } = useAuth();
  const [credentials, setCredentials] = useState({ email: '', password: '', "apiType" : "login" });
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
};

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      //await login(credentials);
      const response = await login(credentials);
      const data = response.data;
      //console.log("Data = ", data.message);
      console.log("Data = ", data);
      //alert(data.message);

      if(data.success){
       navigate('/Dashboard');
      }
      if(data.success === undefined){
        //navigate('/Dashboard');
      }
      else{
        setError(data.message);
      }
    } catch (error) {
      // Extract meaningful message
      const message = error.response?.data?.message || 
                      error.message || 
                      'Login failed. Please try again.';
      setError(message);
    }
    finally{
      setLoading(false);
    }
  };

  const [scrolled, setScrolled] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 100;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navbarStyle = {
    backgroundColor: scrolled ? '#1e3799' : '#1e3799',
    transition: 'background-color 0.3s ease-in-out'
  };

  return (
    <>  
<div className="container">
      <div className="row justify-content-center">
        <div className="col-md-6 mt-5 mb-5">
          <div className="card shadow">
            <div className="card-body">
              <h2 className="card-title text-center mb-4">Login</h2>
              {error && <div className="alert alert-danger">{error}
              <span type="button" className="text-right" onClick={() => setError(false)} style={{float: 'right'}}> 
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg ml-5" viewBox="0 0 16 16">
    <path d="M2.146 2.146a.5.5 0 0 1 .708 0L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854a.5.5 0 0 1 0-.708z"/>
  </svg>
          </span>
                </div>}
              <form onSubmit={handleLogin}>
            <MDBRow tag="form" className='g-3 text-left'>
                        <MDBCol md="12">
                        <label>Username</label>
                        <MDBInputGroup textBefore={<i class='fa fa-envelope prefix red-text'></i>} className='mb-3'>
        <input className='form-control' type='text' 
        value={credentials.email}
        onChange={(e) => setCredentials({...credentials, email: e.target.value})}
        />
      </MDBInputGroup>
      </MDBCol>
      </MDBRow>
                
                <MDBRow tag="form" className='g-3 text-left'>
                        <MDBCol md="12">
                          <label>Password</label>                     
      <MDBInputGroup className='mb-3' textBefore={<i class='fa fa-lock prefix red-text'></i>} textAfter= {showPassword ? <MDBIcon icon='eye-slash' style={{fontSize:'100%', color:'black'}} type='button' onClick={togglePasswordVisibility}/> : <MDBIcon icon='eye' type='button' onClick={togglePasswordVisibility} style={{fontSize:'100%', color:'red'}}/> }>
        <input type={showPassword ? "text" : "password"} className='form-control'
         value={credentials.password}
         onChange={(e) => setCredentials({...credentials, password: e.target.value})} 
         />
      </MDBInputGroup>
      </MDBCol>
                     </MDBRow>
                     <button type="submit" className="btn btn-primary w-100"
                     disabled= {credentials.email ==="" || credentials.password === "" || loading}
                     >
  {!loading ? (
    'Login'
  ) : (
    <>
      Loading <MDBSpinner grow size="lg" />
    </>
  )}
</button>
              </form>
            </div>
          </div>      
        </div>
      </div>
    </div>
    </>
  );
}